import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Feature } from "ol";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { AccordionItem } from "../../Elements/Accordion";
import { DrawType } from "../../Map/enums";
import { SketchProps } from "./SketchProps";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import { DrawingButton } from "./DrawingButton";
import { useAppContext } from "../../Contexts/AppContext";

const allowedQuantity = 5;

export const DrawLVMRoads = (): JSX.Element => {
    const { clickedFeatures, setClickedFeatures, drawType } = useAppContext();
    const { drawnFeatures } = useRegistrationContext();
    const { addFromSearch, selectedFeature, setSelectedFeature } = useDrawingContext();

    const [editFeature, setEditFeature] = useState<Feature>(undefined);
    const [noteFeatures, setNoteFeatures] = useState<Feature[]>([
        ...drawnFeatures.filter((f) => f.get("DRAWTYPE") === DrawType.PolylineLvmRoad)
    ]);

    useEffect(() => {
        setNoteFeatures([...drawnFeatures.filter((f) => f.get("DRAWTYPE") === DrawType.PolylineLvmRoad)]);
    }, [drawnFeatures]);

    useEffect(() => {
        const clickedLVMRoadFeature =
            clickedFeatures &&
            clickedFeatures.length &&
            clickedFeatures.find(
                (f) =>
                    f.get("DRAWTYPE") === DrawType.PolylineLvmRoad &&
                    f.get("OBJECTID") &&
                    !noteFeatures.find((noteFeature) => noteFeature.get("MASTERID") === f.get("OBJECTID"))
            );

        clickedLVMRoadFeature && noteFeatures.length < allowedQuantity && addSelected(clickedLVMRoadFeature);
    }, [clickedFeatures]);

    useEffect(() => {
        drawType !== DrawType.PolylineLvmRoad && setClickedFeatures(undefined);
    }, [drawType]);

    useEffect(() => {
        setEditFeature(selectedFeature);
    }, [selectedFeature]);

    const addSelected = (clickedLVMRoad: Feature) => {
        addFromSearch(createFeature(clickedLVMRoad));
        setClickedFeatures(undefined);
    };

    const createFeature = (clickedLVMRoad?: Feature) => {
        const newFeature = new Feature();
        newFeature.setGeometry(clickedLVMRoad.getGeometry());
        newFeature.setProperties({
            TYPE: 1,
            DRAWTYPE: DrawType.PolylineLvmRoad,
            MASTERID: Number(clickedLVMRoad.get("OBJECTID")),
            MASTERNAME: clickedLVMRoad.get("ROADSUBTYPE") === 2 ? clickedLVMRoad.get("ROADNAME") : "Dabiska brauktuve"
        });
        return newFeature;
    };

    const onClickToolbar = (feature: Feature) => {
        setEditFeature(feature);
        setSelectedFeature(feature);
    };

    const title = `LVM autoceļi (${noteFeatures.length || 0}/${allowedQuantity})`;

    return (
        <AccordionItem title={title} changeHeight={Date.now()} defaultExpanded={noteFeatures.length} key="LVM autoceļi">
            <div className="draw-toolbar">
                <DrawingButton
                    iconClass={"icon-geo-select-finger"}
                    type={DrawType.PolylineLvmRoad}
                    disabled={noteFeatures.length >= allowedQuantity}
                ></DrawingButton>
            </div>
            {noteFeatures &&
                noteFeatures.map((f, i) => (
                    <div key={(f.get("MASTERNAME") || "bez nosaukuma") + i}>
                        {editFeature && editFeature.get("TEMPID") === f.get("TEMPID") ? (
                            <SketchProps feature={f} placeholder={"Piezīmes"}></SketchProps>
                        ) : null}
                        <div
                            className={classNames("search-toolbar property-toolbar", {
                                selected: editFeature && editFeature.get("TEMPID") === f.get("TEMPID")
                            })}
                            onClick={() => onClickToolbar(f)}
                        >
                            <div className="search-toolbar-text">
                                <span>{f.get("MASTERNAME") || "bez nosaukuma"}</span>
                            </div>
                        </div>
                    </div>
                ))}
        </AccordionItem>
    );
};
